export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      {/* Background image - right side */}
      <div className="absolute inset-0 flex">
        <div className="hidden md:block w-1/2 bg-background-50"></div>
        <div className="w-full md:w-1/2 relative">
          <img
            src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20flat%20lay%20of%20carefully%20curated%20fashion%20items%20including%20footwear%20accessories%20and%20apparel%20beautifully%20arranged%20on%20a%20soft%20cream%20linen%20textured%20surface%20with%20warm%20gentle%20side%20lighting%20creating%20subtle%20depth%2C%20editorial%20product%20photography%20with%20cohesive%20warm%20beige%20and%20cream%20color%20palette%2C%20clean%20harmonious%20composition%20with%20artful%20negative%20space&width=960&height=1200&seq=hero-main-bg-v2&orientation=portrait"
            alt="Curated pandabuy product sourcing collection"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-background-50 via-background-50/70 to-transparent md:bg-gradient-to-l md:from-transparent md:via-transparent md:to-background-50/60"></div>
        </div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-6 md:px-10 lg:px-16">
        <div className="max-w-[1280px] mx-auto">
          <div className="md:w-1/2 md:pr-12 lg:pr-20">
            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-tight tracking-tight">
              The Ultimate
              <br />
              <span className="text-accent-500">Pandabuy Spreadsheet</span>
              <br />
              System
            </h1>
            <p className="mt-6 text-foreground-600 text-base md:text-lg leading-relaxed max-w-lg">
              Discover curated <strong>pandabuyspreadsheet</strong> lists, compare shopping agents, and optimize your product sourcing workflow with structured data-driven spreadsheets. Updated weekly for serious buyers.
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-4">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="group whitespace-nowrap inline-flex items-center gap-3 px-7 py-3.5 bg-primary-500 text-background-50 text-sm font-semibold rounded-full hover:bg-primary-600 transition-all duration-300 cursor-pointer"
              >
                Pandabuy Sheet
                <span className="w-6 h-6 flex items-center justify-center border border-background-50/30 rounded-full transition-transform duration-300 group-hover:translate-x-0.5">
                  <i className="ri-arrow-right-up-line text-xs"></i>
                </span>
              </a>
              <a
                href="/pandabuy-sheet-guide"
                className="group whitespace-nowrap inline-flex items-center gap-2 px-7 py-3.5 border border-foreground-200 text-foreground-800 text-sm font-medium rounded-full hover:border-foreground-400 hover:bg-background-100 transition-all duration-300 cursor-pointer"
              >
                Explore Guide
                <span className="transition-transform duration-300 group-hover:translate-x-0.5">
                  <i className="ri-arrow-right-line text-base"></i>
                </span>
              </a>
            </div>

            {/* Trust badges */}
            <div className="mt-10 flex items-center gap-6 text-foreground-500 text-xs font-medium">
              <span className="flex items-center gap-1.5">
                <i className="ri-checkbox-circle-line text-accent-500 text-sm"></i>
                100+ Curated Lists
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-checkbox-circle-line text-accent-500 text-sm"></i>
                Updated Weekly
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-checkbox-circle-line text-accent-500 text-sm"></i>
                Free Access
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}